import type { EditorCanvas } from "replo-utils/lib/misc/canvas";
import type { SetActiveCanvasSource } from "./canvas-types";

import * as React from "react";

import useRightBarVisibility from "@v1/hooks/useRightBarVisibility";
import { useEditorDispatch } from "@v1/store/store";

import { setActiveCanvas } from "./canvas-reducer";

export default function useSetActiveCanvas() {
  const isRightBarVisible = useRightBarVisibility();
  const dispatch = useEditorDispatch();
  return React.useCallback(
    ({
      canvas,
      width,
      source,
    }: {
      canvas: EditorCanvas;
      width?: number;
      source: SetActiveCanvasSource;
    }) => {
      dispatch(
        setActiveCanvas({
          canvas,
          width,
          isRightBarVisible,
          source,
        }),
      );
    },
    [dispatch, isRightBarVisible],
  );
}
